module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAECAYAAADmrJ2uAAAAUklEQVQoU2MUU7AMYGZgrGdgYDRgGEDwn+H/g38M/wsZJRSs7jMyMCoMoFuQrP5/AeSgB4wMjPKDw0EMFxkhUcbUwMDAoD+QjvrP8P/hP4b/BQDaPRMJtHq/HAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wap/add.png
// module id = W3W0
// module chunks = 1